var ExtendzApiConfig = /** @class */ (function () {
    function ExtendzApiConfig(config) {
        this.config = config;
        this.modelsEndpont = 'models';
        if (config.svgIconSet)
            this.svgIconSet = config.svgIconSet;
    }
    return ExtendzApiConfig;
}());
export { ExtendzApiConfig };
//# sourceMappingURL=extendzApi.config.js.map